import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_SUBMODULES_TABLE_STORAGE_KEY = "moduleVersionSubmodulesTableStorageKey";
export const MODULE_VERSION_SUBMODULES_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionSubmodulesTableFiltersStorageKey";

export enum MODULE_VERSION_SUBMODULES_COLUMN_ID {
  NAME = "NAME",
  INSTRUCTIONS = "INSTRUCTIONS",
}

const MAX_CELL_WIDTH = 600;
const INSTRUCTIONS_COLUMN_WIDTH = 90;

export const MODULE_VERSION_SUBMODULES_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_SUBMODULES_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    // Settings are hidden on this table, so there is no chrome to hide, pin, or move against.
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.INSTRUCTIONS]: {
    id: MODULE_VERSION_SUBMODULES_COLUMN_ID.INSTRUCTIONS,
    title: "Actions",
    noHeader: true,
    minWidth: INSTRUCTIONS_COLUMN_WIDTH,
    defaultWidth: INSTRUCTIONS_COLUMN_WIDTH,
    maxWidth: INSTRUCTIONS_COLUMN_WIDTH,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

/** Drives the table when the version can't show instructions, so no empty Actions column renders. */
export const MODULE_VERSION_SUBMODULES_NAME_ONLY_COLUMNS_CONFIG: Record<
  MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME,
  TableColumnMeta
> = {
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME]:
    MODULE_VERSION_SUBMODULES_TABLE_COLUMNS_CONFIG[MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME],
};

/** INSTRUCTIONS is here only to satisfy the exhaustive Record; nothing reads it (allowsSorting: false). */
export const SORT_CONFIG: Record<MODULE_VERSION_SUBMODULES_COLUMN_ID, string> = {
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME]: "name",
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.INSTRUCTIONS]: "instructions",
};

export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
